import React, { useEffect, useState } from 'react';
import { Check, Crop, Image as ImageIcon, RotateCcw, RotateCw, Sparkles, X, Zap } from 'lucide-react';
import type { OfficerScreen } from '../../types/officer';
interface CameraCaptureProps {
  go: (s: OfficerScreen) => void;
  rotation: number;
  setRotation: (r: number) => void;
  enhanced: boolean;
  setEnhanced: (e: boolean) => void;
}
export function CameraCapture({
  go,
  rotation,
  setRotation,
  enhanced,
  setEnhanced
}: CameraCaptureProps) {
  const [detected, setDetected] = useState(false);
  const [captured, setCaptured] = useState(false);
  const [cropped, setCropped] = useState(false);
  const [flash, setFlash] = useState(false);
  useEffect(() => {
    if (captured) return;
    setDetected(false);
    const t = setTimeout(() => setDetected(true), 1400);
    return () => clearTimeout(t);
  }, [captured]);
  const capture = () => {
    setFlash(true);
    setTimeout(() => {
      setFlash(false);
      setCaptured(true);
    }, 180);
  };
  return <div className="relative flex flex-1 flex-col overflow-hidden bg-black text-white" data-id="element-354" data-mp="7g2qpcr7wrk1">
      <div className="flex items-center justify-between px-4 py-3" data-id="element-355" data-mp="bhe7css462g3">
        <button onClick={() => go('home')} aria-label="বন্ধ করুন" className="rounded-full bg-white/10 p-2" data-id="element-356" data-mp="bfl1vgt8lo9o"><X className="h-5 w-5" data-id="element-357" data-mp="ghacivcjrzx8" /></button>
        <span className="text-sm font-medium" data-id="element-358" data-mp="lfbv7f629x86">{captured ? 'ছবি সম্পাদনা' : 'নোটিশ স্ক্যান'}</span>
        <button aria-label="ফ্ল্যাশ" className="rounded-full bg-white/10 p-2" data-id="element-359" data-mp="3jxhij8ifq996"><Zap className="h-5 w-5" data-id="element-360" data-mp="3jv4rm5up8ojz" /></button>
      </div>

      <div className="relative mx-4 flex-1 overflow-hidden rounded-2xl bg-[#3b3a36]" data-id="element-361" data-mp="3oxc91ayaswtp">
        <div className="absolute left-1/2 top-1/2 w-[72%] origin-center transition-all duration-500" style={{
        transform: `translate(-50%,-50%) rotate(${captured ? rotation : -4}deg) ${captured ? '' : 'perspective(600px) rotateX(8deg)'}`,
        filter: enhanced ? 'contrast(1.25) brightness(1.08) grayscale(0.2)' : 'brightness(0.92)'
      }} data-id="element-362" data-mp="3tv3yzzfdu8v9">
          <div className="scan-paper aspect-[210/297] rounded-sm p-3 font-serifbn text-[6px] leading-[1.6] text-slate-700 shadow-2xl" data-id="element-363" data-mp="363gdxy4sxs0w">
            <div className="text-center font-bold" data-id="element-364" data-mp="2u41ji4uqrypl">ঢাকা মেট্রোপলিটন পুলিশ</div>
            <div className="text-center" data-id="element-365" data-mp="37uwvhq0jevxe">ট্রাফিক বিভাগ (তেজগাঁও)</div>
            <div className="mt-2 flex justify-between" data-id="element-366" data-mp="37x10kba6a0z9"><span data-id="element-367" data-mp="32vbocsb7rh9l">স্মারক নং-৬৪১/১৭৭১</span><span data-id="element-368" data-mp="32x4u85e05xgj">১৪/০৬/২০২৫</span></div>
            <div className="mt-2" data-id="element-369" data-mp="32y69yn5yr84l">প্রাপক: মোঃ মিলন মিয়া</div>
            <div data-id="element-370" data-mp="2f70w2djl2pwx">দেওয়ানদাড়ি, ত্রিশাল, ময়মনসিংহ</div>
            <div className="mt-2 font-bold" data-id="element-371" data-mp="2b4xgbcpvsz5u">বিষয়: সড়ক পরিবহন আইন, ২০১৮ এর ১১৮ ধারা…</div>
            {Array.from({
            length: 9
          }).map((_, i) => <div key={i} className="mt-1 h-[3px] rounded bg-slate-400/60" style={{
            width: `${70 + i * 13 % 30}%`
          }} data-id="element-372" data-mp="2p5gnyiqfq37h" data-mpi={i} />)}
            <div className="mt-3 text-right" data-id="element-373" data-mp="2k40xuc9eh6i8">উপ-পুলিশ কমিশনার</div>
          </div>
          {(detected || captured) && !cropped && <div className="pointer-events-none absolute -inset-1 rounded border-2 border-[#4ade80] shadow-[0_0_0_9999px_rgba(0,0,0,0.25)]" data-id="element-374" data-mp="3vkhgeeg9439b">
              {['-left-1.5 -top-1.5', '-right-1.5 -top-1.5', '-left-1.5 -bottom-1.5', '-right-1.5 -bottom-1.5'].map(c => <span key={c} className={`absolute h-3 w-3 rounded-full border-2 border-white bg-[#4ade80] ${c}`} data-id="element-375" data-mp="1mde3cdrzrbf8" />)}
            </div>}
        </div>
        {!captured && <div className="absolute left-0 right-0 top-3 mx-auto w-fit rounded-full bg-black/60 px-3 py-1.5 text-[12px]" data-id="element-376" data-mp="1dc63vsdqo4jk">
            {detected ? '✓ নোটিশের সীমানা শনাক্ত হয়েছে' : 'নোটিশটি ক্যামেরার ফ্রেমের মধ্যে রাখুন'}
          </div>}
        {cropped && <div className="absolute left-0 right-0 top-3 mx-auto w-fit rounded-full bg-[#16834A] px-3 py-1.5 text-[12px]" data-id="element-377" data-mp="1raxf9717vc40">✓ স্বয়ংক্রিয়ভাবে ক্রপ করা হয়েছে</div>}
        {flash && <div className="absolute inset-0 bg-white" data-id="element-378" data-mp="1w862vn54w8cn" />}
      </div>

      {!captured ? <div className="flex items-center justify-around px-6 py-6" data-id="element-379" data-mp="2jy0ek1dpvqvb">
          <button aria-label="গ্যালারি" onClick={() => go('preview')} className="rounded-xl bg-white/10 p-3" data-id="element-380" data-mp="2oqjngl1glxts"><ImageIcon className="h-6 w-6" data-id="element-381" data-mp="104qrx5eyddr5" /></button>
          <button aria-label="ছবি তুলুন" onClick={capture} disabled={!detected} className={`flex h-[72px] w-[72px] items-center justify-center rounded-full border-4 ${detected ? 'border-white' : 'border-white/40'}`} data-id="element-382" data-mp="102e4icqfeb6p">
            <span className={`h-14 w-14 rounded-full ${detected ? 'bg-white' : 'bg-white/40'}`} data-id="element-383" data-mp="m4piv2ojb00l" />
          </button>
          <span className="w-12 text-center text-[10px] text-white/60" data-id="element-384" data-mp="1ivhwltnzwfz7">স্বয়ংক্রিয় শনাক্তকরণ চালু</span>
        </div> : <div className="px-4 pb-5 pt-4" data-id="element-385" data-mp="1euo8az6n4z5s">
          <div className="grid grid-cols-4 gap-2 text-[11px]" data-id="element-386" data-mp="1evr33i733lqz">
            {[{
          label: 'পুনরায়',
          icon: RotateCcw,
          on: false,
          act: () => {
            setCaptured(false);
            setCropped(false);
            setRotation(0);
            setEnhanced(false);
          }
        }, {
          label: 'ক্রপ',
          icon: Crop,
          on: cropped,
          act: () => setCropped(c => !c)
        }, {
          label: 'ঘোরান',
          icon: RotateCw,
          on: rotation !== 0,
          act: () => setRotation((rotation + 90) % 360)
        }, {
          label: 'উন্নত করুন',
          icon: Sparkles,
          on: enhanced,
          act: () => setEnhanced(!enhanced)
        }].map(t => {
          const Icon = t.icon;
          return <button key={t.label} onClick={t.act} className={`flex flex-col items-center gap-1 rounded-xl py-2 ${t.on ? 'bg-[#1769AA]' : 'bg-white/10'}`} data-id="element-387" data-mp="2f1bjp4xpcjlt">
                  <Icon className="h-5 w-5" data-id="element-388" data-mp="2j0tv9a3mvibz" /> {t.label}
                </button>;
        })}
          </div>
          <button onClick={() => go('preview')} className="mt-4 flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-[#16834A] font-semibold" data-id="element-389" data-mp="2t0t2n3obh2n9"><Check className="h-5 w-5" data-id="element-390" data-mp="2xsktzgfarceg" /> ছবি ব্যবহার করুন</button>
        </div>}
    </div>;
}